export const parseJson = (json) => {
  return typeof json === 'string' ? JSON.parse(json || '{}') : json;
};
